module.exports = __webpack_public_path__ + "img/content-16.92bbc49.png";